Service = App.loadClass 'core::Angular/Service'

class exports.SafeLinkService extends Service
    constructor: (@http, @rootScope) ->
        @limit = 15
        @start = 0


    loadSafeLink: (search, append) =>
        if not append
            @start = 0
        else
            @start += @limit

        return @http.post 'backend/grower/home/load-safe-link',
            search: search,
            start: @start,
            limit: @limit


    fetchPermissions: (user_id) =>
        return @http.post 'backend/grower/session-mgmt/safe-link',
            users_id: user_id


    loadAccessUser: () =>
        return @http.get 'backend/grower/home/access-user'

    loadCompany: () =>
        return @http.get 'backend/user-info/company'
